if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');

        // Collect line item properties. Personalization apps (Uploadly file upload,
        // Zepto product personalizer) and theme blocks may render their
        // properties[...] inputs outside the product form, so scan the document.
        const props = {};
        document.querySelectorAll("[name*='properties[']").forEach((el) => {
          if (el.disabled) return;
          if (el.type === 'file') return;
          if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
          const match = el.name.match(/properties\[([^\]]+)\]/);
          if (!match) return;
          if (el.value === '' || el.value == null) return;
          props[match[1]] = el.value;
        });

        const qtyInput = this.form.querySelector('[name=quantity]');
        const mainItem = {
          id: Number(this.form.querySelector('[name=id]').value),
          quantity: qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1,
          properties: props,
        };
        const sellingPlan = this.form.querySelector('[name=selling_plan]');
        if (sellingPlan && sellingPlan.value) mainItem.selling_plan = Number(sellingPlan.value);

        const body = { items: [mainItem] };

        // Custom add-ons (name charm / handwritten gift note)
        const meta_prod = document.querySelector('#meta_prod:checked')?.dataset.id;
        const gift_product = document.querySelector('#gift_product:checked')?.dataset.id;
        if (meta_prod)
          body.items.push({
            id: Number(meta_prod),
            quantity: 1,
            properties: { Name: document.querySelector('#product-content_input-main')?.value },
          });
        if (gift_product)
          body.items.push({
            id: Number(gift_product),
            quantity: 1,
            properties: { 'Handwritten Note': document.querySelector('#product-content_input')?.value },
          });

        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(body);

        // We open the drawer ourselves below, so tell the global cart-add
        // observer (in custom.js) to skip this particular add and avoid a
        // double render.
        window.__nsSkipNextCartAdd = true;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              window.__nsSkipNextCartAdd = false;
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainItem.id,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainItem.id,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const spinnerEl = this.querySelector('.loading-overlay__spinner');
            if (spinnerEl) spinnerEl.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
